<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Customers | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			Gross Profit
		</div>
		<div class="card-body overflow-auto">
      <div class="col-sm-4">
				<div class="form-group">
					<span class="right badge badge-secondary">Select From Date:</span>
      		<input type="date" class="form-control" v-model="from" placeholder="Select from date">
      	</div>
			</div>
      <div class="col-sm-4">
				<div class="form-group">
					<span class="right badge badge-secondary">Select To Date:</span>
      		<input type="date" class="form-control" v-model="to" placeholder="Select to date">
      	</div>
      </div>
      <div class="col-sm-4">
				<div class="form-group float-left">
      		<button class="btn btn-primary" @click="getGP"><i class="fa fa-search"></i> Search</button>
      	</div>
			</div>
			<br><br>
			<div class="col-sm-6">
				<h4>Expense: {{expense}}</h4>
				<h4>Income: {{income}}</h4>
				<h4>GP: {{profit}}</h4>
			</div>
			<div class="col-md-12">
				<datatable style="margin-top:1%;" :columns="columns">
					<tbody>
						<tr v-for="expense in expenses" :key="expense.id">
							<td>{{expense.type}}</td>
							<td>{{expense.description}}</td>
							<td>{{expense.amount}}</td>
							<td>{{expense.date}}</td>
							<td>{{expense.created_date}}</td>
						</tr>
					</tbody>
				</datatable>
			</div>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getExpenses(pagination.prevPageUrl)"
        @next="getExpenses(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 import Datatable from '../../datatable.vue';
     import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        created(){
        	this.getExpenses();
        	this.getExpenseTypes();
        },
        
        data(){
        	let columns = [
        		{width:'10%', label:'Type', name:'type'},
      			{width:'20%', label:'Descripiton', name:'description'},
      			{width:'20%', label:'Amount', name:'amount'},
      			{width:'10%', label:'Date', name:'date'},
      			{width:'20%', label:'Entered On', name:'created_date'}
        	];
        	return {
        		columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		expenses: [],
         		expense_types: [],
        		from: '',
        		to: '',
        		expense: '',
        		income: '',
        		profit: ''
        	}
        },
        
        methods: {
        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},
    			
    			getExpenses(){
    				axios.post("/api/getExpenses", {from: this.from, to: this.to})
    				.then(response => {
    					this.expenses = response.data.data.data;
    					this.configPagination(response.data.data);
    				})
    			},
    			
    			getExpenseTypes(){
    				axios.post("/api/getAllExpenseTypes")
    				.then(response => {
    					this.expense_types = response.data;
    				})
    			},
    			
        	getGP(){
        		axios.post("/api/getGPManager", {from: this.from, to: this.to})
        		.then(response => {
        			this.expense = response.data.expense;
        			this.income = response.data.income;
        			this.profit = response.data.gp;
        			this.getExpenses();
        		})
        	}
        }
    }
</script>
